class MapGallery extends HTMLElement {
  constructor() {
    super();

    this.intersectionObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.querySelector(".icon").classList.add("drop");
          this.intersectionObserver.unobserve(entry.target);
        }
      }
    });

    this.RegionCompanies = RegionCompanies;
    this.zoom = 12;
    this.markerList = [];
    this.mapWrapper = this.querySelector("#map");
    this.initMap();

    this.markers = [];
  }

  async initMap() {
    // Initialization Location
    const position = { lat: 53.512736, lng: -2.369423 };
    // Request needed libraries.
    //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const geocoder = new google.maps.Geocoder();
    const bounds = new google.maps.LatLngBounds();

    this.map = new Map(this.mapWrapper, {
      mapId: "DEMO_MAP_ID",
      gestureHandling: "cooperative",
      streetViewControl: false,
      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        mapTypeIds: ["roadmap"],
      },
    });

    this.style.opacity = 0.4;

    if (this.RegionCompanies.length > 0) {
      this.RegionCompanies.forEach((company, index) =>
        this.createMarker({
          geocoder,
          AdvancedMarkerElement,
          company,
          address: company.address,
          bounds,
        })
      );
    } else {
      this.createMarker({
        geocoder,
        AdvancedMarkerElement,
        address: this.extractLastSegment(window.location.pathname),
        bounds,
      });
    }
  }

  createMarker({
    geocoder,
    AdvancedMarkerElement,
    company = false,
    address,
    bounds,
  }) {
    geocoder &&
      geocoder.geocode({ address }, (results, status) => {
        if (status == "OK" && results) {
          const marker = new AdvancedMarkerElement({
            map: this.map,
            position: results[0].geometry.location,
            title: company ? company.name : address,
            gmpClickable: true,
          });

          bounds.extend(marker.position);

          if (company) {
            marker.content = this.markAddress(company);
            this.markers.push(marker);
            marker.addListener("click", (e) => {
              if (e.domEvent.target.hasAttribute("href")) {
                return window.open(
                  e.domEvent.target.getAttribute("href"),
                  "_self"
                );
              }

              this.toggleHighlight(marker);
            });
            this.centralize(bounds);
            this.map.getZoom() > this.zoom && this.map.setZoom(this.zoom);
          } else {
            this.centralize(bounds);
            this.map.setZoom(8);
          }

          this.style.opacity = 1;
        } else {
          bounds.extend({ lat: 53.512736, lng: -2.369423 });
          this.centralize(bounds);

          this.map.setZoom(8);
          this.style.opacity = 1;

          console.log(
            "Geocode was not successful for the following reason: " + status
          );
        }
      });
  }

  markAddress(company) {
    const content = document.createElement("div");
    content.classList.add("company");
    content.innerHTML = `
      <div class="icon"></div>
      <div class="details"><div class="titlee text--large">${company.name}</div>
          <div class="address">${company.map_summary}</div>
          <a href="${company.url}" onclick="event.stopPropagation();" class="strong link">${company.label}</a>
      </div>
    `;

    const delay = 1 + Math.random();
    content.style.setProperty("--delay-time", delay + "s");

    this.intersectionObserver.observe(content);
    return content;
  }

  centralize = (bounds) => this.map.fitBounds(bounds);

  toggleHighlight(markerView) {
    this.markers.forEach((marker) => {
      if (marker === markerView) return;

      marker.zIndex = -1;
      marker.content.classList.remove("highlight");
    });

    markerView.content.classList.toggle("highlight");

    if (markerView.content.classList.contains("highlight")) {
      markerView.zIndex = null;
    } else {
      markerView.zIndex = 1;
    }
  }

  extractLastSegment = (pathname) =>
    pathname.split("/")[pathname.split("/").length - 1];
}

customElements.define("map-gallery", MapGallery);
